// extracted by mini-css-extract-plugin
module.exports = {"sidebar_container":"sidebar_sidebar_container__1_bAk","sidebar_list":"sidebar_sidebar_list__2zvVe flex_column"};